import { render, staticRenderFns } from "./patrol02.vue?vue&type=template&id=bd71abae"
import script from "./patrol02.vue?vue&type=script&lang=js"
export * from "./patrol02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd71abae')) {
      api.createRecord('bd71abae', component.options)
    } else {
      api.reload('bd71abae', component.options)
    }
    module.hot.accept("./patrol02.vue?vue&type=template&id=bd71abae", function () {
      api.rerender('bd71abae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrol02.vue"
export default component.exports